import '../style/home/H_Ads.css';


const H_Ads=()=>{
  return(
    <div className="h-ads">
      <div className="h-ads-text">
        <span> تا 40 درصد تخفیف استثنایی</span> ویژه عضویت یکساله آزمون مدرسه دانش 
      </div>
      <div className="h-ads-btn">
        مشاهده تعرفه‌ها
      </div>
    </div>
  )
}

export default H_Ads;